module.exports = __webpack_public_path__ + "img/lhb.c4885943.svg";